import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PetitionsStatePage } from './petitions-state';

@NgModule({
  declarations: [
    PetitionsStatePage,
  ],
  imports: [
    IonicPageModule.forChild(PetitionsStatePage),
  ],
})
export class PetitionsStatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/petitions-state/petitions-state.module.ts